<template>
  <section v-if="usersChatRoomIds !== null" class="h-full bg-purple-600 bg-gradient-to-r from-purple-600 via-purple-500 to-purple-600 rounded-xl shadow-xl p-2">
    
    <div ref="mainContainer" class="overflow-x-hidden overflow-y-auto h-full white-small-scroll">
      <div ref="scrollContainer">
        <div class="flex justify-center px-4 py-10 space-y-4 lg:space-y-0 lg:space-x-4 flex-col lg:flex-row row-span-2">
        <div class="hidden flex-shrink-0 max-w-sm lg:table mx-auto">
          <img  src="/add_chat.svg" alt="person with add icon">
        </div>
        <div class="flex">
          <h2 class="text-pink-100 uppercase text-3xl lg:text-5xl xl:text-7xl font-bold table my-auto tracking-wider leading-snug text-center lg:text-left h-max w-full">Find a chat room</h2>
        </div>
      </div>

      <div class="flex justify-center">

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-2 w-full">

          <chat-room-card  v-for="(room,key) in allChatRoom" :key="key" class="w-full max-w-xs mx-auto" :chatRoom="room" :chatRoomId="key" @joinChatRoom="()=>{ $emit('joinChatRoom',key) }"  @errorIcon="()=>{ $emit('errorIcon',key) }" @setChatRoomInfo="(room,key,isAlreadyMember)=>{ $emit('setChatRoomInfo',room,key,isAlreadyMember)}" :isAlreadyMember="false" :isDarkColor="false" ></chat-room-card>

        </div>
        
      </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import ChatRoomCard from '@/components/ChatRoomCard.vue';

export default {
  data(){
    return {
      isAddingChatRoom : false,
    }
  },
  emits : ['joinChatRoom','errorIcon','setChatRoomInfo','bottomScrolled'],
  components : {
    'chat-room-card' : ChatRoomCard,
  },
  props : {
    allChatRoom : Object,
    usersChatRoomIds : Array
  },
  mounted() {
    if(this.$refs.mainContainer)this.$refs.mainContainer.addEventListener("scroll", this.checkIfOnBottom)
  },
  beforeUnmount(){
    if(this.$refs.mainContainer)this.$refs.mainContainer.removeEventListener("scroll", this.checkIfOnBottom);
  },
  methods : {
    checkIfOnBottom() {
      if(this.isAddingChatRoom)return;
      const mainContainer  = this.$refs.mainContainer;
      const scrollContainer =  this.$refs.scrollContainer;
      // console.log(mainContainer.offsetHeight + mainContainer.scrollTop, scrollContainer.offsetHeight );
      if ((mainContainer.offsetHeight + mainContainer.scrollTop) >= (scrollContainer.offsetHeight ) ) {
        this.isAddingChatRoom = true;
        this.$emit('bottomScrolled');
      }
    },
  },
  computed : {
    allChatRoomLength(){
      if(!this.allChatRoom)return 0;
      return Object.keys(this.allChatRoom).length;
    }
  },
  watch : {
    allChatRoomLength(length,prevLength){
      if(length > prevLength)this.isAddingChatRoom = false;
    }
  }

}
</script>

<style>

</style>